import React from "react";
import { Field, ErrorMessage, FieldInputProps } from "formik";
import InputWithIcon from "../../../components/input/input";
import MaskedInput from "../../../components/input/inputMask";
import { FiUser } from "react-icons/fi";
import { FaRegAddressCard } from "react-icons/fa6";
import { MdCorporateFare } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { CiPhone } from "react-icons/ci";
import { TitleInput } from "@/screens/register/register-seller/style";
import { ErrorText, MarginBottom } from "@/screens/login/login-buy/style";
import { useTranslation } from "react-i18next";

interface Props {
  selectedOption: number;
  registerError: any[];
}

const StepBasicInfo: React.FC<Props> = ({ selectedOption, registerError }) => {
  const { t } = useTranslation();
  return (
    <>
      <TitleInput>{t("name")}</TitleInput>
      <Field name="business_name">
        {({ field }: { field: FieldInputProps<any> }) => (
          <InputWithIcon icon={<FiUser />} iconSize="23px" field={field} placeholder={t("type-name")} />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="business_name" />
      </ErrorText>

      {selectedOption === 1 && (
        <>
          <MarginBottom />
          <TitleInput>CPF</TitleInput>
          <Field name="document">
            {({ field }: { field: FieldInputProps<any> }) => (
              <MaskedInput field={field} icon={<FaRegAddressCard />} iconSize="23px" mask="999.999.999-99" placeholder={t("type-document")} />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="document" />
          </ErrorText>
        </>
      )}

      {selectedOption === 2 && (
        <>
          <MarginBottom />
          <TitleInput>CNPJ</TitleInput>
          <Field name="cnpj">
            {({ field }: { field: FieldInputProps<any> }) => (
              <MaskedInput field={field} icon={<FaRegAddressCard />} iconSize="23px" mask="99.999.999/9999-99" placeholder={t("type-cnpj")} />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="cnpj" />
          </ErrorText>

          <MarginBottom />
          <TitleInput>{t("corporate-reason")}</TitleInput>
          <Field name="corporate_name">
            {({ field }: { field: FieldInputProps<any> }) => (
              <InputWithIcon icon={<MdCorporateFare />} iconSize="23px" field={field} placeholder={t("type-company-name")} />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="corporate_name" />
          </ErrorText>

          <MarginBottom />
          <TitleInput>{t("state-registration")}</TitleInput>
          <Field name="state_registration">
            {({ field }: { field: FieldInputProps<any> }) => (
              <InputWithIcon icon={<MdCorporateFare />} iconSize="23px" field={field} placeholder={t("type-state-registration")} />
            )}
          </Field>
          <ErrorText>
            <ErrorMessage name="state_registration" />
          </ErrorText>
        </>
      )}

      <MarginBottom />
      <TitleInput>{t("phone")}</TitleInput>
      <Field name="phone">
        {({ field }: { field: FieldInputProps<any> }) => (
          <MaskedInput field={field} icon={<CiPhone />} mask="(99) 99999-9999" iconSize="23px" placeholder={t("type-phone")} />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="phone" />
      </ErrorText>

      <MarginBottom />
      <TitleInput>{t("email")}</TitleInput>
      <Field name="email">
        {({ field }: { field: FieldInputProps<any> }) => (
          <InputWithIcon icon={<MdOutlineEmail />} iconSize="23px" field={field} placeholder={t("type-email")} />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="email" />
      </ErrorText>
    </>
  );
};

export default StepBasicInfo